// extracted by mini-css-extract-plugin
module.exports = {"self":"Tile-module--self--12GQD","background":"Tile-module--background--A42M7","name":"Tile-module--name--tHrnn","gradient":"Tile-module--gradient--3UZwu"};